import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import AraSec from '../ui/AraSec';

type Cari = { id: number; name: string };
type Teklif = { id: number; no: string; cari: string; totalKurus: number; status: string };

export default function YeniSiparis({ kapat, eklendi }: { kapat: () => void; eklendi: () => void }) {
  const [cariler, setCariler] = useState<Cari[]>([]);
  const [teklifler, setTeklifler] = useState<Teklif[]>([]);
  const [customerId, setCustomerId] = useState('');
  const [title, setTitle] = useState('');
  const [source, setSource] = useState('TELEFON');
  const [dueDate, setDueDate] = useState('');
  const [depositTl, setDepositTl] = useState('');
  const [note, setNote] = useState('');
  const [hata, setHata] = useState<string | null>(null);
  const [bekliyor, setBekliyor] = useState(false);

  useEffect(() => {
    api<{ cariler: Cari[] }>('/api/cariler').then((r) => setCariler(r.cariler)).catch(() => undefined);
    api<{ satirlar: Teklif[] }>('/api/teklif?durum=GONDERILDI')
      .then((r) => setTeklifler(r.satirlar)).catch(() => undefined);
  }, []);

  async function tekliftenAc(quoteId: number) {
    setHata(null); setBekliyor(true);
    try {
      await api(`/api/siparis/tekliften/${quoteId}`, { method: 'POST' });
      eklendi();
    } catch (e) {
      setHata(e instanceof Error ? e.message : 'Açılamadı');
    } finally {
      setBekliyor(false);
    }
  }

  async function gonder(e: React.FormEvent) {
    e.preventDefault();
    setHata(null); setBekliyor(true);
    try {
      await api('/api/siparis', {
        method: 'POST',
        body: JSON.stringify({
          customerId: Number(customerId), title, source,
          dueDate: dueDate || undefined,
          depositTl: depositTl ? Number(depositTl) : undefined,
          note: note || undefined,
        }),
      });
      eklendi();
    } catch (err) {
      setHata(err instanceof Error ? err.message : 'Kaydedilemedi');
    } finally {
      setBekliyor(false);
    }
  }

  return (
    <div className="ccd-drawer-arka" onClick={kapat} role="presentation">
      <aside className="ccd-drawer" onClick={(e) => e.stopPropagation()}
             role="dialog" aria-modal="true" aria-label="Yeni sipariş">
        <div className="ccd-stack">
          <div className="ccd-row-between">
            <div>
              <div className="ccd-eyebrow">Sipariş</div>
              <h2 className="ccd-heading">Yeni sipariş</h2>
            </div>
            <button className="ccd-btn ccd-btn-ghost ccd-btn-sm" onClick={kapat}>Kapat</button>
          </div>

          {hata && (
            <div className="ccd-banner ccd-banner-danger">
              <span className="ccd-banner-icon">!</span><span>{hata}</span>
            </div>
          )}

          {teklifler.length > 0 && (
            <div className="ccd-card ccd-stack-sm">
              <div className="ccd-fieldset-title">Gönderilmiş tekliften aç</div>
              <div className="ccd-meta">
                Tek tıkla sipariş açılır, teklif "satışa döndü" olur ve zincir bağlanır.
              </div>
              {teklifler.slice(0, 8).map((t) => (
                <div key={t.id} className="ccd-row-between">
                  <span><b className="ccd-mono">{t.no}</b> · {t.cari}</span>
                  <button className="ccd-btn ccd-btn-accent ccd-btn-sm" disabled={bekliyor}
                          onClick={() => tekliftenAc(t.id)}>
                    Sipariş aç
                  </button>
                </div>
              ))}
            </div>
          )}

          <form className="ccd-stack" onSubmit={gonder}>
            <div className="ccd-fieldset-title">Ya da elle</div>
            <div className="ccd-field">
              <label className="ccd-field-label" htmlFor="scari">
                Cari<span className="ccd-required"> *</span>
              </label>
              <AraSec id="scari" required deger={customerId} degis={setCustomerId}
                      secenekler={cariler.map((c) => ({ id: c.id, ad: c.name }))} yerTutucu="Cari adı yazın…" />
            </div>
            <div className="ccd-field">
              <label className="ccd-field-label" htmlFor="sbas">
                Başlık<span className="ccd-required"> *</span>
              </label>
              <input id="sbas" className="ccd-input" required value={title}
                     onChange={(e) => setTitle(e.target.value)}
                     placeholder="Nilüfer villa · banyo seramikleri" />
            </div>
            <div className="ccd-form-grid">
              <div className="ccd-field">
                <label className="ccd-field-label" htmlFor="skay">Geliş kanalı</label>
                <select id="skay" className="ccd-select" value={source}
                        onChange={(e) => setSource(e.target.value)}>
                  <option value="TELEFON">Telefon</option>
                  <option value="MAIL">Mail</option>
                  <option value="YUZYUZE">Yüz yüze</option>
                </select>
              </div>
              <div className="ccd-field">
                <label className="ccd-field-label" htmlFor="ster">Termin</label>
                <input id="ster" className="ccd-input" type="date" value={dueDate}
                       onChange={(e) => setDueDate(e.target.value)} />
              </div>
            </div>
            <div className="ccd-field">
              <label className="ccd-field-label" htmlFor="skap">Kapora (TL)</label>
              <input id="skap" className="ccd-input" type="number" inputMode="decimal" step="any" value={depositTl}
                     onChange={(e) => setDepositTl(e.target.value)} />
            </div>
            <div className="ccd-field">
              <label className="ccd-field-label" htmlFor="snot2">Not</label>
              <input id="snot2" className="ccd-input" value={note}
                     onChange={(e) => setNote(e.target.value)} />
            </div>
            <button className="ccd-btn ccd-btn-primary ccd-btn-lg" disabled={bekliyor}>
              {bekliyor ? 'Kaydediliyor…' : 'Siparişi aç'}
            </button>
          </form>
        </div>
      </aside>
    </div>
  );
}
